import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import Button from '../Button';
import Headline from '../Headline';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import styles from './style.module.scss';
import { Row, Col } from 'reactstrap';
import CloseIcon from '../icons/Close';
/**
 * The dialogs title
 * @param {Children}  children  The react children
 **/

var Title = function Title(_ref) {
  var children = _ref.children;
  return React.createElement(Headline, {
    size: 3,
    pseudo: true,
    noMargin: true
  }, children);
};
/**
 * The dialogs content
 * @param {Children}  children  The react children
 **/


var Content = function Content(_ref2) {
  var children = _ref2.children;
  return React.createElement(Row, null, React.createElement(Col, {
    id: "alert-dialog-description",
    className: styles.content
  }, children));
};
/**
 * The dialogs actions
 * @param {Children}  children  The react children
 **/


var Actions = function Actions(_ref3) {
  var children = _ref3.children;
  return React.createElement("div", {
    className: styles.actions
  }, React.createElement(DialogActions, null, children));
};
/**
 * A simple alert dialog
 * @param {Children}          children            The button that activates the dialog
 * @param {String}            title               The dialogs title
 * @param {String}            content             The dialogs content
 * @param {boolean}           open                Open or close state if handled by parent component
 * @param {void}              onClose             On close event hook. Should set open prop to false
 * @param {[Title, Content]}  custom              A custom dialog body
 * @param {React.Component}   customActions       A complete custom action bar
 * @param {React.Component}   customHeaderActions Custom actions for header
 * @param {Object}            PaperProps          Apply custom Styles on AlertDialog Root
 */


var AlertDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(AlertDialog, _React$Component);

  function AlertDialog(props) {
    var _this;

    _classCallCheck(this, AlertDialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlertDialog).call(this, props));

    _this.handleClickOpen = function () {
      _this.setState({
        open: true
      });
    };

    _this.handleClose = function () {
      _this.setState({
        open: false
      });

      _this.props.onClose();
    };

    _this.renderChildren = function () {
      return React.Children.map(_this.props.children, function (child, index) {
        return React.cloneElement(child, {
          onClick: _this.handleClickOpen
        });
      });
    };

    _this.renderAdditionalActions = function () {
      return _this.props.additionalActions ? _this.props.additionalActions : '';
    };

    _this.renderCloseButton = function () {
      return React.createElement(IconButton, {
        "aria-label": "Close",
        onClick: _this.handleClose
      }, React.createElement(CloseIcon, null));
    };

    _this.state = {
      open: _this.props.open || false
    };
    return _this;
  }
  /**
   * Opens the dialog
   **/


  _createClass(AlertDialog, [{
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.renderChildren(), React.createElement(ResponsiveDialog, Object.assign({}, this.props, {
        open: this.props.open !== undefined ? this.props.open : this.state.open,
        handleClose: this.handleClose,
        renderAdditionalActions: this.renderAdditionalActions,
        renderCloseButton: this.renderCloseButton
      })));
    }
  }]);

  return AlertDialog;
}(React.Component);

var ResponsiveDialog = withWidth()(function (_ref4) {
  var title = _ref4.title,
      content = _ref4.content,
      custom = _ref4.custom,
      showCloseButton = _ref4.showCloseButton,
      customActions = _ref4.customActions,
      handleClose = _ref4.handleClose,
      open = _ref4.open,
      hideOkButton = _ref4.hideOkButton,
      renderAdditionalActions = _ref4.renderAdditionalActions,
      renderCloseButton = _ref4.renderCloseButton,
      width = _ref4.width,
      customHeaderActions = _ref4.customHeaderActions,
      PaperProps = _ref4.PaperProps;
  return React.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    fullScreen: isWidthDown('sm', width),
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    PaperProps: PaperProps
  }, React.createElement(DialogTitle, {
    disableTypography: true
  }, title && React.createElement(Title, null, title), React.createElement("div", {
    className: styles.headerActionsBar
  }, customHeaderActions && customHeaderActions, showCloseButton && renderCloseButton())), React.createElement(DialogContent, null, content && React.createElement(Content, null, content), custom && custom), customActions ? customActions : React.createElement(DialogActions, null, renderAdditionalActions(), !hideOkButton && React.createElement(Button, {
    onClick: handleClose,
    color: "dark",
    variant: "text",
    size: "small"
  }, "Ok")));
});
AlertDialog.defaultProps = {
  onClose: function onClose() {}
};
AlertDialog.Title = Title;
AlertDialog.Content = Content;
AlertDialog.Actions = Actions;
export default AlertDialog;